import { Icon } from '@/components/foundations';

export type StoreInfo = { name: string; id: string };
export const DEFAULT_STORE: StoreInfo = { name: 'Lisboon Store', id: '123456' };

/** Loja atual no rodapé da sidebar (`.store`). */
export function StoreSwitcher({ name, id, href = '#' }: StoreInfo & { href?: string }) {
  return (
    <a className="store" href={href}>
      <Icon name="store" className="si" />
      <div>
        <b>{name}</b>
        <small>ID: {id}</small>
      </div>
      <Icon name="chev" className="chev" />
    </a>
  );
}
